module.exports = __webpack_public_path__ + "img/AccesoOficina_Boveda_ATM.72a47a1e.svg";